import request from '@/sheep/request';
import type { LimitCheckinRecordValues } from './limitCheckinRecordValues';

// 用户自律项
export interface LimitUserProjects {
	id : number
	projectIcon ?: string
	projectDescription ?: string
	dailyLimit ?: number
	userId ?: number
	projectId ?: number
	projectName ?: string
	customAlias ?: string
	dailyGoal ?: string
	customDefaults ?: string
	remindTime ?: string
	isHidden ?: boolean
	isCheckIn ?: boolean
	isCompensate ?: boolean
	checkinTime ?: string
	recordValues ?: LimitCheckinRecordValues[]
	description ?: string
	isLast ?: boolean
	continuousDays ?: number
	sort ?: number
	status ?: boolean
	createTime ?: any
}

// 创建用户自律项
export const createLimitUserProjects = async (data : Partial<LimitUserProjects>) => {
	return request({
		url: '/wish/user-projects/create',
		method: 'POST',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '添加成功'
		},
	});
}

// 更新用户自律项
export const updateLimitUserProjects = async (data : Partial<LimitUserProjects>) => {
	return request({
		url: '/wish/user-projects/update',
		method: 'PUT',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '更新成功'
		},
	});
}

// 删除用户自律项
export const deleteLimitUserProjects = async (id : number) => {
	return request({
		url: '/wish/user-projects/delete',
		method: 'DELETE',
		params: { id },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 批量删除用户自律项
export const deleteLimitUserProjectsList = async (ids : number[]) => {
	return request({
		url: '/wish/user-projects/delete-list',
		method: 'DELETE',
		params: { ids },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 获得用户自律项
export const getLimitUserProjects = async (id : number) => {
	return request({
		url: '/wish/user-projects/get',
		method: 'GET',
		params: { id },
		custom: {
			auth: true
		},
	});
}

// 获得用户自律项分页
export const getLimitUserProjectsPage = async (params : any) => {
	return request({
		url: '/wish/user-projects/page',
		method: 'GET',
		params,
		custom: {
			auth: true
		},
	});
}

// 获得用户自律项
export const getLimitUserProjectsList = async (params : any) => {
	return request({
		url: '/wish/user-projects/list',
		method: 'GET',
		params,
		custom: {
			auth: true
		},
	});
}

export interface LimitCheckinValue {
	fieldId : number
	fieldValue ?: string
}

export interface LimitCheckinData {
	userProjectId : number
	checkinDate ?: string
	isCompensate ?: boolean
	values ?: LimitCheckinValue[]
	description ?: string
}

// 用户自律项打卡（聚合接口：创建打卡记录 + 字段值）
export const checkinLimitUserProject = async (data : LimitCheckinData) => {
	return request({
		url: '/wish/user-projects/checkin',
		method: 'POST',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '打卡成功'
		},
	});
}